import { render } from "./CxRefModelOverlayControls.vue?vue&type=template&id=36b06bca"
import script from "./CxRefModelOverlayControls.vue?vue&type=script&lang=js"
export * from "./CxRefModelOverlayControls.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__